<main class="request__container" *ngIf="request && request.detail">
  <section class="request-detail__breadcrumbs" *ngIf="breadcrumbsItems">
    <scc-dsm3-nav-breadcrumbs [disableHomeIcon]="true" [items$]="breadcrumbsItems$"></scc-dsm3-nav-breadcrumbs>
  </section>
  <section class="request-detail__container">
    <header class="request-detail__header">
      <h1 class="request-detail__title">{{ requestTypeTitle }}</h1>
    </header>

    <div class="request-detail__row">
      <div class="request-detail__row-col">
        <article class="request-detail__article">
          <p class="request-detail__article-value">
            <span class="request-detail__article-label">ID</span>
            {{ request.detail.requestMainId || '-' }}
          </p>
          <p class="request-detail__article-value">
            <span class="request-detail__article-label">Criado por</span>
            {{ request.detail.createdBy || '-' }}
          </p>
          <p class="request-detail__article-value">
            <span class="request-detail__article-label">Data de criação</span>
            {{ request.detail.createdAt | amFromUtc | amDateFormat: 'DD/MM/YYYY' || '-' }}
          </p>
        </article>
      </div>
      <div class="request-detail__row-col" *appRequestPermission="createPermission">
        <div
          class="request-detail__cancel-request"
          *ngIf="showActions()"
          tabindex="0"
          role="button"
          (click)="requestDetailService.cancelRequest()"
          (keydown)="($event.key === 'Enter' || $event.key === ' ') && requestDetailService.cancelRequest()"
        >
          Anular pedido
        </div>
      </div>
    </div>
  </section>

  <section class="request-detail__section">
    <div class="request-detail__process">
      <div class="request-detail__process-item">
        <span class="request-detail__process-item-title">Área</span>
        <p class="request-detail__process-item-value">{{ request.detail.requestArea || '-' }}</p>
      </div>
      <div class="request-detail__process-item">
        <span class="request-detail__process-item-title">Tipo</span>
        <span class="request-detail__process-item-value">{{ request.detail.requestType || '-' }}</span>
      </div>
      <div class="request-detail__process-item">
        <span class="request-detail__process-item-title">Sub-tipo</span>
        <span class="request-detail__process-item-value">{{ request.detail.requestSubType || '-' }}</span>
      </div>
      <div class="request-detail__process-item">
        <span class="request-detail__process-item-title">CPE</span>
        <span class="request-detail__process-item-value">{{ request.detail.requestCpe || '-' }} </span>
      </div>
      <div class="request-detail__process-item">
        <span class="request-detail__process-item-title">Nível de tensão</span>
        <span class="request-detail__process-item-value">{{ request.detail.voltageLevelTitle || '-' }}</span>
      </div>
      <div class="request-detail__process-item" *ngIf="request.detail.requestDescription">
        <span class="request-detail__process-item-title">Descrição</span>
        <span class="request-detail__process-item-value"
          >{{ request.detail.requestDescription | shorten: maxLength : '...' }}
          <a
            class="request-detail__process-item-read-more"
            *ngIf="request.detail.requestDescription.length > 120"
            (click)="showFullDescription()"
            (keydown)="($event.key === 'Enter' || $event.key === ' ') && showFullDescription()"
            tabindex="0"
            title="Ver{{ readMoreLabel }}"
            >{{ readMoreLabel }}</a
          ></span
        >
      </div>
    </div>
  </section>

  <section class="request-detail__section">
    <h2 class="request-detail__section-title">
      Estado do pedido
      <span class="request-detail__status request-detail__status-{{ request.detail.statusClass }}">{{
        request.detail.statusTitle
      }}</span>
    </h2>

    <div class="request-detail__file-form" *appRequestPermission="writePermission">
      <form [formGroup]="sendCommentForm">
        <div class="forms__field">
          <scc-dsm3-textarea-control
            [formGroup]="sendCommentForm"
            formName="comment"
            [placeholder]="commentPlaceholder"
            [maxlength]="commentMaxlength"
            [errorsMessage]="{
              required: 'Campo de preenchimento obrigatório.',
              maxlength: 'Máximo de 3500 caracteres.',
            }"
          ></scc-dsm3-textarea-control>
        </div>
        <div class="forms__field">
          <scc-dsm3-multi-upload-control
            [formGroup]="sendCommentForm"
            formName="files"
            [fileTypes]="fileTypes"
            [fileSizeLimit]="fileSizeLimit"
            [placeholder]="filePlaceholder"
          ></scc-dsm3-multi-upload-control>
        </div>
        <div class="forms__field">
          <div class="request-detail__file-form-submit">
            <button class="request-detail__btn-submit" (click)="sendComment(0)" [disabled]="!checkValidForm()">
              Submeter
            </button>
          </div>
        </div>
      </form>
    </div>

    <div
      class="request-detail__message-accordeon"
      [class.request-detail__message-accordeon-open]="!expandMessageAccordeon"
    >
      <h3 class="request-detail__message-accordeon-title">
        Mensagens
        <span
          *ngIf="request.comments.length > 3"
          class="icon icon--medium icon--chevron-bottom request-detail__message-accordeon-arrow"
          (click)="expandMessages()"
          (keydown)="($event.key === 'Enter' || $event.key === ' ') && expandMessages()"
          tabindex="0"
          role="button"
          aria-label="Expandir mensagens"
        ></span>
      </h3>
      <div class="request-detail__message-accordeon-list" *ngIf="request.comments.length > 0; else emptyMessagesList">
        <div
          class="request-detail__message-accordeon-item"
          *ngFor="let item of request.comments | slice: 0 : maxMessages; let i = index"
        >
          <div class="request-detail__message-accordeon-info">
            <span class="request-detail__message-accordeon-user">
              <i
                *ngIf="requestDetailService.checkIsRetailer(item.createdUserIsInternal)"
                class="request-detail__message-accordeon-user-icon icon icon--small icon--about-us"
              ></i>
              {{ item.userName }}
            </span>
            <span class="request-detail__message-accordeon-date">
              {{ requestDetailService.formatDateWithString(item.createdAt | amFromUtc | amLocal) }}</span
            >
          </div>

          <div class="request-detail__message-accordeon-content">
            <p>{{ item.commentText }}</p>
            <div
              *ngIf="item.countAttachments === 1"
              (click)="downloadFile(item)"
              (keydown)="($event.key === 'Enter' || $event.key === ' ') && downloadFile(item)"
              tabindex="0"
              role="button"
              class="request-detail__message-accordeon-attachments"
            >
              <i class="request-detail__message-accordeon-attachments-icon icon icon--medium icon--docs"></i>
              <span class="request-detail__message-accordeon-attachments-label"
                >{{ item.countAttachments }} documento anexado</span
              >
            </div>
            <div
              *ngIf="item.countAttachments > 1"
              (click)="seeAttachmentsList(item.commentUniqueCode)"
              (keydown)="($event.key === 'Enter' || $event.key === ' ') && seeAttachmentsList(item.commentUniqueCode)"
              tabindex="0"
              role="button"
              class="request-detail__message-accordeon-attachments"
            >
              <i class="request-detail__message-accordeon-attachments-icon icon icon--medium icon--docs"></i>
              <span class="request-detail__message-accordeon-attachments-label"
                >{{ item.countAttachments }} documentos anexados</span
              >
            </div>
          </div>
        </div>
      </div>
      <ng-template #templateCustomModal>
        <h3 class="request-detail__modal-title">Lista de Anexos</h3>
        <ul *ngIf="attachList.length > 0" class="request-detail__modal-attachments-list">
          <li
            *ngFor="let attachment of attachList"
            (click)="downloadFile(attachment)"
            (keydown)="($event.key === 'Enter' || $event.key === ' ') && downloadFile(attachment)"
            tabindex="0"
            role="button"
            class="request-detail__message-accordeon-attachments"
          >
            <i class="request-detail__message-accordeon-attachments-icon icon icon--medium icon--docs"></i>
            <span class="request-detail__message-accordeon-attachments-label">{{ attachment.fileName }}</span>
          </li>
        </ul>
      </ng-template>
      <ng-template #emptyMessagesList>
        <div class="request-detail__message-accordeon-list">
          <p class="request-detail__message-accordeon-item request-detail__message-accordeon-item-empty">
            De momento não existem mensagens.
          </p>
        </div>
      </ng-template>
    </div>
  </section>

  <div class="row toChangeLaterFutureUs" *appRequestPermission="internalNotesPermission">
    <div class="col-md-6 text-left">
      <h2 color="black">
        {{ request.detail.requestOperationType | uppercase }} - {{ request.detail.requestMainId | uppercase }}
      </h2>
    </div>
    <div class="col-md-6 text-right btn-actions">
      <!-- BUTTON ACTION NOT RET && REOPEN -->
      <div class="btn-group" *appRequestPermission="internalNotesPermission">
        <button
          type="button"
          *ngIf="showActions()"
          class="edp-btn btn-yellow dropdown-toggle"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          Ações <span class="caret"></span>
        </button>
        <ul class="dropdown-menu dropdown-menu-right">
          <li
            class="cursor-pointer"
            *ngIf="request.possibleStatus.length > 0"
            (click)="requestDetailService.changeStatus(request.detail)"
            (keydown)="
              ($event.key === 'Enter' || $event.key === ' ') && requestDetailService.changeStatus(request.detail)
            "
            tabindex="0"
            role="button"
          >
            Alterar estado
          </li>
          <li
            class="cursor-pointer"
            (click)="requestDetailService.changeType(request.detail)"
            (keydown)="
              ($event.key === 'Enter' || $event.key === ' ') && requestDetailService.changeType(request.detail)
            "
            tabindex="0"
            role="button"
          >
            Alterar tipo
          </li>
          <li
            class="cursor-pointer"
            *ngIf="request.realocatable"
            (click)="requestDetailService.changeRealocate(request.detail)"
            (keydown)="
              ($event.key === 'Enter' || $event.key === ' ') && requestDetailService.changeRealocate(request.detail)
            "
            tabindex="0"
            role="button"
          >
            Realocar EDP
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="row" *appRequestPermission="internalNotesPermission">
    <div class="col-md-12">
      <h2 color="black" class="mb">NOTA(S) INTERNA(S)</h2>
      <table
        class="table middle"
        *ngIf="request.internalComments && request.internalComments.length > 0; else elseNoInternalComments"
      >
        <thead>
          <tr>
            <th>Utilizador</th>
            <th>Nota interna</th>
            <th>Estado</th>
            <th>Data de criação</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of request.internalComments">
            <td width="16%">{{ item.userName || '-' }}</td>
            <td width="56%" class="word-break text-left">{{ item.commentText || '-' }}</td>
            <td width="12%">
              {{
                requestDetailService.checkIsRetailer(item.createdUserIsInternal)
                  ? item.statusTitleInternal
                  : item.statusTitleRetailer
              }}
            </td>
            <td width="16%">{{ item.createdAt | amFromUtc | amLocal | amDateFormat: 'DD/MM/YYYY HH:mm' || '-' }}</td>
          </tr>
        </tbody>
      </table>
      <ng-template #elseNoInternalComments>
        <p>De momento não existem notas internas.</p>
      </ng-template>
    </div>
  </div>

  <div class="row" *appRequestPermission="internalNotesPermission">
    <div class="col-md-12">
      <form [formGroup]="sendInternalCommentForm" autocomplete="off" *ngIf="showCommentForm()">
        <div class="form-group">
          <textarea
            formControlName="internalnotes"
            class="form-control"
            id="internalnotes"
            placeholder="Insira a sua nota interna"
          ></textarea>
        </div>
        <div
          class="form-group alert alert-danger text-center"
          *ngIf="sendInternalCommentForm.controls['internalnotes'].hasError('maxlength')"
        >
          Nota interna está a exceder o limite de caracteres.
        </div>
        <div class="form-group">
          <div class="btn-group pull-right">
            <button
              [disabled]="!sendInternalCommentForm.valid"
              type="submit"
              class="edp-btn btn-yellow"
              (click)="sendComment(1)"
            >
              Inserir
            </button>
            <button
              [disabled]="!sendInternalCommentForm.valid"
              type="reset"
              class="edp-btn btn-gray"
              (click)="clearComment(1)"
            >
              Limpar
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>

  <section class="request-detail__section request-detail__section-documents">
    <div
      class="request-detail__document-accordeon"
      [class.request-detail__document-accordeon-open]="!expandDocumentsAccordeon"
    >
      <h2 class="request-detail__section-title">Histórico de Documentos</h2>
      <div class="request-detail__documents-list" *ngIf="requestAttachments.length > 0; else emptyDocumentsList">
        <div
          class="request-detail__document"
          *ngFor="let document of requestAttachments | slice: 0 : maxDocuments; let i = index"
          (click)="downloadFile(document)"
          (keydown)="($event.key === 'Enter' || $event.key === ' ') && downloadFile(document)"
          tabindex="0"
          role="button"
        >
          <i class="request-detail__document-icon icon icon--large icon--docs"></i>
          <div class="request-detail__document-content" *ngIf="document">
            <h3 class="request-detail__document-name">{{ document.fileName }}</h3>
            <div class="request-detail__document-details">
              <span class="request-detail__document-size">{{ requestDetailService.fileSize(document.fileSize) }}</span>
              <span class="request-detail__document-date">{{
                document.createdAt | amFromUtc | amLocal | amDateFormat: 'DD/MM/YYYY' || '-'
              }}</span>
            </div>
          </div>
        </div>
      </div>

      <div
        *ngIf="requestAttachments.length > 4"
        class="request-detail__document-accordeon-footer"
        (click)="expandDocuments()"
        (keydown)="($event.key === 'Enter' || $event.key === ' ') && expandDocuments()"
        tabindex="0"
        role="button"
        aria-label="Expandir documentos"
      >
        <span class="icon icon--medium icon--chevron-bottom request-detail__document-accordeon-arrow"></span>
      </div>

      <ng-template #emptyDocumentsList>
        <div class="request-detail__documents-list request-detail__documents-list-empty">
          <p class="request-detail__document request-detail__document-empty">
            De momento não existem documentos disponíveis.
          </p>
        </div>
      </ng-template>
    </div>
  </section>

  <section class="request-detail__section request-detail__section-footer">
    <button class="request-detail__btn-back" (click)="navigateToList()">Voltar</button>
  </section>
</main>
